/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {Directive, TemplateRef} from '@angular/core';
export class WizardPageButtonsDirective {
/**
 * @param {?} pageButtonsTemplateRef
 */
constructor(public pageButtonsTemplateRef: TemplateRef<any>) {}
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: "[clrPageButtons]"}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TemplateRef, },
];
}

function WizardPageButtonsDirective_tsickle_Closure_declarations() {
/** @type {?} */
WizardPageButtonsDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
WizardPageButtonsDirective.ctorParameters;
/** @type {?} */
WizardPageButtonsDirective.prototype.pageButtonsTemplateRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
